// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Mg_h409lra9SrfsU8wy0b"};